import endpoints from "constants/endpoints";
import { adminApi } from "services/api/client";

export const getNotices = async () => {
  return await adminApi({
    endpoint: endpoints.NOTICES,
    method: "get",
  });
};
